import * as _ from 'underscore'
import { CreateEditController, CreateEditScope } from '../../common/common.create-edit.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'

import { CommonHelper } from '../../../helpers/common-helper'
import { EventsNames } from '../../../helpers/events-names'
import { IUserSession } from '../../../helpers/user-session'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { PopupType } from './../../../helpers/popup-manager'

import { Enums } from '../../../models/common/enums'
import { IOpObject } from '../../../models/util/interfaces'
import { LoggerService } from '../../common/common.module'
import { OpIssue } from '../../../models/core/op-issue'

import { IssueHelper } from '../issues.helper'

interface IssueCreateEditScope extends CreateEditScope {}

export class IssueCreateEditController extends CreateEditController {

    // Members

    private referenceValue: OpIssue;
    private bulkIssues: OpIssue[];

    // Members End


    constructor(
        private $scope: IssueCreateEditScope,
        private $q: ng.IQService, 
        private $timeout: ng.ITimeoutService,
        private logger: LoggerService,
        protected userSession: IUserSession,
        referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenctType)
        this.setEvents()
        this.setOptions()
    }


    // Events

    public onInit(args: any[]): void {
        if (args.length > 0 && args[0]) {
            const createEditInitParams: CreateEditInitParams = args[0]

            this.referenceValue = createEditInitParams ? <OpIssue>createEditInitParams.referenceObject : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)
            
            if (this.referenceValue && this.referenceValue.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }
            
            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }

    public onInitBulk(args: any[]): void {

        if (args.length > 0 && args[0]) {

            let bulkEditInitParams: BulkEditInitParams = args[0]

            // Chwilowe obejście
            this.bulkIssues = bulkEditInitParams['__issues_bulk_edit_data__']

            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)

            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)

            if (args.length > 0 && args[0]) {
                this.$scope.gridData = args[0]
            }

            if (args.length > 0 && args[1]) {
                this.$scope.gridColumns = args[1]
            }

            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    public onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred: any = this.$q.defer<IOpObject>()
        const issue: OpIssue = OpIssue.fromIOpObject(objectToSave)
        
        if (this.referenceValue == null) {
            issue.creationDate = new Date()
        } else {
            issue.creationDate = this.referenceValue.creationDate
        }

        IssueHelper
            .saveIssue(this.userSession.getDataProvider(), issue, this.moduleName, null)
            .then((savedObject: OpIssue) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                this.logger.log(error)
                deferred.reject(error)
            })

        return deferred.promise
    }

    public onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred: any = this.$q.defer<IOpObject>()
        const issue: OpIssue = OpIssue.fromIOpObject(objectToSave)
        issue.opState = Enums.OpChangeState.Modified
        
        if (this.bulkIssues != null) {
            const currentBulkIssue: OpIssue = _.find(this.bulkIssues, (bulkIssue: OpIssue) => {
                return bulkIssue.idIssue === issue.idIssue
            })

            if (currentBulkIssue != null) {
                issue.creationDate = currentBulkIssue.creationDate
            }
        }

        IssueHelper
            .saveIssue(this.userSession.getDataProvider(), issue, this.moduleName, true)
            .then((savedObject: OpIssue) => {
                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                this.logger.log(error)
                deferred.reject(error)
            })

        return deferred.promise
    }

    // Events End


    // Setup

    public setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName), 
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_BULK_EDIT_POPUP, this.moduleName), 
            (event: ng.IAngularEvent, ...args: any[]) => this.onInitBulk(args)
        )
    }

    public setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.options = {
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.issueSaved,
            onSubmit: null,
            onClose: null,
            referenceType: this.referenceType,
            submitBulkEdit: null,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
            title: '',
            type: null,
           
            onBulkSave: (objectToSave: IOpObject) => this.onBulkSave(objectToSave),
            onSave: (objectToSave: IOpObject) => this.onSave(objectToSave),
        }
    }

    // Setup End
}